export default __webpack_public_path__ + "media/images/ico/apple-icon-120-9e2419bbac28ccaf9eb96a8486730c91.png";